/* Smooth-scroll #oc-buy links to the OC buy box wherever it sits on the page. */
(function () {
  function target() {
    return document.querySelector('[data-oc-buy]');
  }
  document.addEventListener('click', function (e) {
    var a = e.target && e.target.closest ? e.target.closest('a[href$="#oc-buy"]') : null;
    if (!a) return;
    var t = target();
    if (!t) return;
    e.preventDefault();
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    t.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
  });
  document.addEventListener('DOMContentLoaded', function () {
    if (location.hash === '#oc-buy') {
      var t = target();
      if (t) setTimeout(function () { t.scrollIntoView({ block: 'start' }); }, 60);
    }
  });
})();
